"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.composeValidators = void 0;
var composeValidators = function (validators) { return function (value) {
    return validators.reduce(function (prevError, validator) {
        if (!Boolean(prevError)) {
            var _a = validator(value), error = _a.error, errorTextValue = _a.errorTextValue;
            if (error) {
                return errorTextValue;
            }
        }
        return prevError;
    }, '');
}; };
exports.composeValidators = composeValidators;
